module.exports = __webpack_public_path__ + "img/bgc1.dcedade5.png";